export default () => ({
  country: "aut",
  intl: {
    fallbackLng: "de",
    locales: [
      {
        locale: "de",
        label: "Deutsch"
      },
      {
        locale: "en",
        label: "English"
      }
    ],
    defaultLocales: [
      {
        locale: "de",
        label: "Deutsch"
      }
    ]
  },
  api: {
    user: {
      workZipCode: "AUT"
    }
  },

  serverTimeZone: 2,

  footer: {
    copyright: "© CINEPLEXX Kinobetriebe Gesellschaft m.b.H.",
    apps: {
      android: "https://play.google.com/store/apps/details?id=at.cineplexx.app",
      ios: "https://itunes.apple.com/at/app/cineplexx-at/id1457257579"
    }
  },

  supportInfo: {
    contactUs: {
      email: "cineplexx@constantinfilm.at"
    }
  },

  form: {
    validation: {
      zip: 4
    }
  },

  wizard: {
    stepTickets: {
      warnings: {
        en: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Attention!</span></strong> The 1 + 1 offer is only available at <strong>Cineplexx Titan (Bucharest)</strong> for tickets purchased at the desk, not online!',
            description:
              "Pay at the cinema to receive a bonus ticket for every cinema ticket purchased"
          }
        ],
        de: [
          {
            title:
              '<strong>Cineplexx Titan || <span class="_accent">Atenție!</span></strong> Oferta 1 + 1 este disponibilă doar la <strong>Cineplexx Titan (București)</strong> pentru biletele achiziționate la casele de bilete, nu și online!',
            description:
              "Pentru a beneficia de un bilet bonus pentru fiecare bilet de film cumpărat, plătește la cinema."
          }
        ]
      }
    },
    stepCheckout: {
      messages: {
        en: [""],
        de: [""]
      }
    }
  },
  showingOptions: {
    member: true,
    giftcards: true,
    streaming: true,
    whatchList: true,
    cinemaRent: true,
    advertising: false,
    newsletter: true,
    newsletterfooter: true,
    newsletterpopup: true,
    wishToReceiveSMS: true,
    contactByThirdParty: true,
    information: true,
    followUs: true,
    myBonusCard: true,
    myGiftCard: true,
    b2bAdvertising: true,
    privacyPolicy: true,
    displayTechnologies: true,
    weeklynewsletter: true,
    familynewsletter: true,
    operanewsletter: true,
    ageratingvisible: true,
    schoolcinema: true,
    childtickets: true,
    company: {
      press: true,
      portrait: true,
      jobs: true
    },
    refundTickets: true,
    club: {
      bonusCard: true,
      familyFilmclub: true,
      competitions: true
    },
    giftCards: {
      giftcardShop: true,
      giftcardInfo: true
    }
  }
});
